import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Field } from './Field';
import { tr } from '../../i18n';

export const ExtrasEditor = ({ extras, onChange, draft, translate }) => {
  const { items, sections } = extras;
  const setItems = (next) => onChange({ ...extras, items: next });
  const update = (i, patch) => setItems(items.map((x, j) => (j === i ? { ...x, ...patch } : x)));
  const remove = (i) => window.confirm('Rimuovere questa aggiunta?') && setItems(items.filter((_, j) => j !== i));
  const add = () => setItems([...items, { _id: `ex-${Date.now()}`, name: { it: '', en: '' }, price: '' }]);
  const toggleSection = (slug) =>
    onChange({ ...extras, sections: sections.includes(slug) ? sections.filter((s) => s !== slug) : [...sections, slug] });
  const translateEn = async (i) => {
    try {
      const en = await translate(items[i].name?.it || '');
      update(i, { name: { ...items[i].name, en } });
    } catch (e) {
      alert('Traduzione fallita: ' + e.message);
    }
  };

  return (
    <section className="bg-white border-[1.5px] border-black rounded-[16px] p-5 md:p-6" data-testid="extras-editor">
      <div className="flex items-center justify-between mb-1 gap-3">
        <h2 className="font-display text-2xl md:text-3xl text-black">Aggiunte</h2>
        <button onClick={add} className="pill-btn text-sm" data-testid="extra-add-btn"><Plus size={14} /> Aggiungi</button>
      </div>
      <p className="text-xs text-black/60 mb-5">Es. Prosciutto crudo +2,00 €, Funghi +1,00 €. Scrivi solo il numero nel prezzo.</p>
      <ul className="space-y-3 mb-8">
        {items.length === 0 && <li className="text-sm text-black/50" data-testid="extras-empty">Nessuna aggiunta. Premi “Aggiungi”.</li>}
        {items.map((x, i) => (
          <li key={x._id || i} className="grid grid-cols-1 md:grid-cols-[1fr_1fr_110px_auto] gap-3 items-end border-b border-black/10 pb-3 md:border-0 md:pb-0" data-testid={`extra-row-${i}`}>
            <Field label="Nome IT" value={x.name?.it || ''} onChange={(v) => update(i, { name: { ...x.name, it: v } })} />
            <Field label="Nome EN" value={x.name?.en || ''} onChange={(v) => update(i, { name: { ...x.name, en: v } })} onTranslate={() => translateEn(i)} translateDisabled={!x.name?.it} />
            <Field label="Prezzo (€)" value={x.price || ''} onChange={(v) => update(i, { price: v })} />
            <button onClick={() => remove(i)} aria-label="Elimina" data-testid={`extra-delete-${i}`} className="p-2.5 text-red-700 hover:text-red-900 justify-self-end">
              <Trash2 size={16} />
            </button>
          </li>
        ))}
      </ul>
      <h3 className="font-display text-xl text-black mb-1">Dove mostrarle</h3>
      <p className="text-xs text-black/60 mb-3">Spunta le sezioni in cui compare il riquadro “Aggiunte”.</p>
      <div className="space-y-4">
        {draft.mainCategories.map((cat) => (
          <div key={cat.slug}>
            <p className="text-[10px] font-bold uppercase tracking-widest text-black/40 mb-1.5">{tr(cat.name, 'it')}</p>
            <div className="flex flex-wrap gap-2">
              {(draft.subCategories[cat.slug] || []).map((s) => {
                const on = sections.includes(s.slug);
                return (
                  <button
                    key={s.slug}
                    type="button"
                    onClick={() => toggleSection(s.slug)}
                    aria-pressed={on}
                    data-testid={`extras-section-${s.slug}`}
                    className={`px-3.5 py-1.5 rounded-full border-[1.5px] border-black text-sm font-bold transition-colors ${on ? 'bg-black text-white' : 'bg-white text-black hover:bg-black/5'}`}
                  >
                    {tr(s.name, 'it')}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ExtrasEditor;
